<template>

  <div v-if="loading">
    <Spinner></Spinner>
  </div>
  <div v-else-if="studentBookings.length == 0">
    No bookings. <a class="underline text-teal" href="/yoga-classes">Explore available classes and book one!</a>
  </div>
  <div v-else>
    <div v-for="session in studentBookings" :key="session.id">
      <SessionLine class="mb-6" :session="session"></SessionLine>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Spinner from './Spinner.vue';
import SessionLine from './SessionLine.vue';

const loading = ref(true);
const studentBookings = ref([]);

onMounted(() => {
  getStudentBookings();
});

const getStudentBookings = async () => {
  const response = await fetch(`/api/sessions/all?currentStudent=1`);
  const data = await response.json();
  studentBookings.value = data.sessions;
  loading.value = false;
  console.log(studentBookings.value);
}
</script>